module.exports = __webpack_public_path__ + "assets/images/eurosport_2.7fbc6267a6c895824b533fea3e306572.png";